import {useParams, useNavigate} from "react-router-dom";
import {useEffect, useRef, useState} from "react";
import {AppPage} from "common/Layout";
import {AppFlex} from "shared/UI/UIKit/Flex";
import {AppButton} from "shared/UI/UIKit/Button";
import {
  getAdditionalMaterialsUrl,
  getAnnotationUrl, getHomeUrl,
  getInteractiveUrl,
  getLiteratureUrl, getMethodologicalModuleUrl, getPracticalModuleUrl,
  getTargetUrl,
  getTestUrl,
  getTheoryUrl, getVideoUrl
} from "services/navigation";
import type {
  InteractivePage as InteractivePageType,
  MethodologicalModulePage as MethodologicalModulePageType,
  Page, PracticalModulePage as PracticalModulePageType
, TheoryPage as TheoryPageType} from "../../config/types";
import {PageType} from "../../config/types";
import {GLOBAL_CONFIG} from "../../config/config";
import styles from "./styles.module.scss";

type InteractivePageParams = {
  id: string;
}

export const InteractivePage = () => {
  const navigate = useNavigate();
  const {id} = useParams<InteractivePageParams>();
  const ref = useRef<HTMLIFrameElement | null>(null);
  const [contentMinHeight, setContentMinHeight] = useState(75);
  const [isLastInteractivePage, setIsLastInteractivePage] = useState(false);
  const interactivePages = GLOBAL_CONFIG.pages.filter(
    page => page.type === PageType.INTERACTIVE
  ) as InteractivePageType[];

  const interactivePage = GLOBAL_CONFIG.pages.find(page => page.type === PageType.INTERACTIVE && page.id === id) as InteractivePageType;
  const currentMethodologicalModule = GLOBAL_CONFIG.pages.find(
      page => page.type === PageType.INTERACTIVE && page.id === id
  ) as MethodologicalModulePageType;

  if (!currentMethodologicalModule) {
    return null;
  }


  const getUrl = (page: Page) => {
    switch (page.type) {
      case PageType.ANNOTATION:
        return getAnnotationUrl();
      case PageType.INTERACTIVE:
        return getInteractiveUrl({id: (page as InteractivePageType).id});
      case PageType.LITERATURE:
        return getLiteratureUrl();
      case PageType.TARGET:
        return getTargetUrl();
      case PageType.TEST:
        return getTestUrl();
      case PageType.THEORY:
        return getTheoryUrl({id: (page as TheoryPageType).id});
      case PageType.VIDEO:
        return getVideoUrl();
      case PageType.METHODOLOGICAL_MODULE:
        return getMethodologicalModuleUrl({id: (page as MethodologicalModulePageType).id});
      case PageType.PRACTICAL_MODULE:
        return getPracticalModuleUrl({id: (page as PracticalModulePageType).id});
      case PageType.ADDITIONAL_MATERIALS:
        return getAdditionalMaterialsUrl();
      default:
        return getHomeUrl();
    }
  };

  const goToNextPage = () => {
    const nextPage = GLOBAL_CONFIG.pages.find(page => page.order === interactivePage.order + 1);

    if (nextPage) {
      const url = getUrl(nextPage);
      navigate(url);
    }
  };

  if (!interactivePage) {
    return null;
  }

  useEffect(() => {
    const currentInteractivePageIdx = interactivePages.findIndex(page => page.id === id);
    setIsLastInteractivePage(currentInteractivePageIdx === interactivePages.length - 1);

    return () => {
      setContentMinHeight(75);
    };
  }, [id]);

  const test = () => {
    if (interactivePage.autoHeight) {
      const body = ref.current?.contentDocument?.getElementsByTagName("body")[0];
      setContentMinHeight(body!.scrollHeight / 10 + 5);
    }
  };

  return (
    <AppPage pageTitle={interactivePage.title}
             documentTitle={interactivePage.title}
             style={{minHeight: contentMinHeight + "rem"}}>
      <iframe ref={ref} onLoad={test} frameBorder="none" className={styles.iframe}
              src={interactivePage.htmlPath}/>
      {!isLastInteractivePage && <AppButton className={styles.nextPageBtn} onClick={goToNextPage}>Далее</AppButton>}
      <AppFlex unit="0" className={styles.container} justifyContent="flex-start">
        <AppButton className={styles.nextPageBtn} onClick={goToNextPage}>
          {currentMethodologicalModule.nextBtnName}
        </AppButton>
      </AppFlex>
    </AppPage>
  );
};

